import { useContext } from "react";

import { FiltersV2StateContext } from "./FiltersV2Context";

const useFiltersV2State = () => useContext(FiltersV2StateContext);

export default useFiltersV2State;
